module.exports = __webpack_public_path__ + "img/skater.3b79fc23.png";